import request from '@/utils/request'
export function getRevisePrice(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/getRevisePrice',
    method: 'post',
    data
  })
}
export function updateRevisePrice(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/updateRevisePrice',
    method: 'post',
    data
  })
}
export function deleteRevisePrice(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/deleteRevisePrice',
    method: 'post',
    data
  })
}
export function getDisInfo(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/getDisInfo',
    method: 'post',
    data
  })
}
export function updateDisInfo(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/updateDisInfo',
    method: 'post',
    data
  })
}
export function saveListByType(data) {
  return request({
    url: '/icps/system/sign/cloudSell/creditStatus/save',
    method: 'post',
    data
  })
}
export function getListByType(data) {
  return request({
    url: '/icps/system/sign/cloudSell/creditStatus/getListByType',
    method: 'post',
    data
  })
}
// 账款
export function getListByid(data) {
  return request({
    url: '/icps/system/sign/cloudSell/accounts/getListByid',
    method: 'post',
    data
  })
}
export function saveOrUpdateaccounts(data) {
  return request({
    url: '/icps/system/sign/cloudSell/accounts/saveOrUpdate',
    method: 'post',
    data
  })
}
export function deletesaccounts(data) {
  return request({
    url: '/icps/system/sign/cloudSell/accounts/deletes',
    method: 'post',
    data
  })
}

export function getDetails(data) {
  return request({
    url: '/icps/system/sign/cloudSell/accountTotal/getDetails',
    method: 'post',
    data
  })
}
export function Update(data) {
  return request({
    url: '/icps/system/sign/cloudSell/accountTotal/Update',
    method: 'post',
    data
  })
}
/*账款导入*/
export function inputData(data) {
  return request({
    url: '/icps/system/sign/cloudSell/accounts/inputData',
    method: 'post',
    data
  })
}
/*风险管控*/
export function getDetailsRiskControl(data) {
  return request({
    url: '/icps/system/sign/cloudSell/assess/getAssessDetails',
    method: 'post',
    data
  })
}
export function updateRiskControl(data) {
  return request({
    url: '/icps/system/sign/cloudSell/assess/updateRiskControl',
    method: 'post',
    data
  })
}
/**
 * @Description: 工程履约分配账号
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function saveOrupdate(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringUser/saveOrupdate',
    method: 'post',
    data
  })
}
/**
 * @Description: 工程履约查看产品信息
 * @Param: 
 * @Author: yijiaxin
 * @param {*} data
 */
 export function getDisClostProduct(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/getDisClostProduct',
    method: 'post',
    data
  })
}
/**
 * @Description: 工程履约保存产品信息
 * @Param: 
 * @Author: yijiaxin
 * @param {*} data
 */
 export function updateDisClostProduct(data) {
  return request({
    url: '/icps/system/sign/cloudSell/disclose/updateDisClostProduct',
    method: 'post',
    data
  })
}
/**
 * @Description: 获取已分配账号
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getOrupdate(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringUser/getOrupdate',
    method: 'post',
    data
  })
}

/**
 * @Description: 获取已分配账号
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getUserByRoleId(data) {
  return request({
    url: '/base/system/user/getUserByRoleId',
    method: 'post',
    data
  })
}
/**根据用户id和类型获取为用户授权的功能 */
export function clientGet_function(data) {
  return request({
    url: '/base/system/app/client/get_function',
    method: 'post',
    data
  })
}
/**工艺流程权限检测 */
export function judeJurisdiction(data) {
  return request({
    url: '/icps/system/sign/basics/technological/jurisdiction_engineering',
    method: 'post',
    data
  })
}
/**
 * @Description: 根据ID获取合同单位详情
 * @param {*}
 * @Author: wangwangwang
 */
export function queryOneById(data) {
  return request({
    url: '/icps/system/sign/cloudsell/custommanage/queryOneById',
    method: 'post',
    data
  })
}
/**
 * @Description: 修改财务编码
 * @param {*}
 * @Author: wangwangwang
 */
 export function changefinacialCode(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/UpdateFinancialCode',
    method: 'post',
    data
  })
}
//获取历史供应状态
 export function queryPhaseHistory(params) {
  return request({
    url: '/icps/system/sign/cloudSell/control/queryPhaseHistory',
    method: "get",
    params,
  })
}
//获取收款计划
 export function queryPageSkPlan(data) {
  return request({
    url: '/icps/system/sign/cloudSell/collectionMoneyPlan/queryPage',
    method: "post",
    data,
  })
}
//获取收款计划
 export function queryPagePlan(data) {
  return request({
    url: '/icps/system/sign/cloudSell/collectionMoneyPlan/queryPage',
    method: "post",
    data,
  })
}
//保存收款计划
 export function saveOrUpdatePlan(data) {
  return request({
    url: '/icps/system/sign/cloudSell/collectionMoneyPlan/saveOrUpdatePlan',
    method: "post",
    data,
  })
}
//删除收款计划
 export function deletePlan(data) {
  return request({
    url: '/icps/system/sign/cloudSell/collectionMoneyPlan/deletePlan',
    method: "post",
    data,
  })
}
//保存共享信息
 export function updateEngineeringExtend(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/updateEngineeringExtend',
    method: "post",
    data,
  })
}
//获取共享项目编码和共享合同编码
 export function queryShareProjectList(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringExtend/queryShareProjectList',
    method: "post",
    data,
  })
}
//保存共享项目编码和共享合同编码
 export function saveShareProject(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringExtend/saveShareProject',
    method: "post",
    data,
  })
}